/**
 * Rich Text Editor - MultiRow Toolbar Sample
 */
import Toolbar from './toolbar';
import React from 'react';
import './style.css';
import ProfilePicture from "profile-picture";
import "profile-picture/build/ProfilePicture.css";
import {   TextField ,Fab} from '@material-ui/core';
import {Button, FormControl,Form,Modal} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import html2canvas  from 'html2canvas';
import jsPDF from 'jspdf';
import Header from '../header';
import {useState} from 'react';
function Example() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button>

      
    </>
  );
}
export default class CV extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {msg : false} 
          
    // Binding this keyword 
    this.handelSubmit = this.handelSubmit.bind(this) 
    this.profilePictureRef = React.createRef();
    this.show=false;
  }
  handelSubmit(){
    this.setState({msg : true});
    alert("ssa");

}
handleUpload() {
  

 this.show=true;
 window.location.reload();
  //add here the upload logic...
}

  
      addCom(){
        var div_=document.getElementById("comp");
        
        var div = document.createElement('div');
        div.className = 'form-group';
        
        var div1 = document.createElement('div');
        div1.style="display:flex";
        
        var input = document.createElement('input');
        input.height="50px"
        input.className = 'form-control';
        input.id = 'inputText';
        //commentText.rows = '3';
        input.placeholder = "L'intitule de votre competence*";
        input.width="100px";
        input.id=document.getElementById("btn_com").name;
document.getElementById("btn_com").name=(parseInt(document.getElementById("btn_com").name)+1)+"";
        var date=document.createElement("input");
        date.style="margin-left:10px";
        date.id=document.getElementById("btn_com").name;
        document.getElementById("btn_com").name=(parseInt(document.getElementById("btn_com").name)+1)+"";

        var br=document.createElement("br");
        date.type="date";
        div1.appendChild(input);
        div1.appendChild(date);
        
        div.appendChild(div1);
       div_.appendChild(div1);
        div_.appendChild(br);
              }
      addExp(){
        var div_=document.getElementById("exp");
        
        var div = document.createElement('div');
        div.className = 'form-group';
        
        var div1 = document.createElement('div');
        div1.style="display:flex";
        
        var input = document.createElement('input');
        input.height="50px"
        input.className = 'form-control';
        input.id = 'inputText';
        //commentText.rows = '3';
        input.placeholder = "L'intitule de votre experience ";
        input.width="100px";
        input.id=document.getElementById("btn_exp").name;
        document.getElementById("btn_exp").name=(parseInt(document.getElementById("btn_exp").name)+1)+"";
        var input1 = document.createElement('input');
        input1.height="50px"
        input1.className = 'form-control';
        //commentText.rows = '3';
        input1.placeholder = "Nom de l'etablissment";
        input1.width="100px";
        input1.id=document.getElementById("btn_exp").name;
        document.getElementById("btn_exp").name=(parseInt(document.getElementById("btn_exp").name)+1)+"";
        var date=document.createElement("input");
        date.style="margin-left:10px";
        date.id=document.getElementById("btn_exp").name;
        document.getElementById("btn_exp").name=(parseInt(document.getElementById("btn_exp").name)+1)+"";
        var datef=document.createElement("input");
        datef.style="margin-left:10px";
        datef.id=document.getElementById("btn_exp").name;
        document.getElementById("btn_exp").name=(parseInt(document.getElementById("btn_exp").name)+1)+"";
        var br=document.createElement("br");
        date.type="date";
        div1.appendChild(input);
        div1.appendChild(input1);

        div1.appendChild(date);
        div1.appendChild(datef);

        alert(document.getElementById("btn_ens").name);  
        //div.appendChild(div1);
        div_.appendChild(div1);
        div_.appendChild(br);

              }
              toresult(){
                var name=document.getElementById("name").value;
                var addresse=document.getElementById("adresse").value;
                var num_tel=document.getElementById("num_tel").value;
                var date_n=document.getElementById("date_birth").value;
                var mail =document.getElementById("mail").value;
                var linkd=document.getElementById("linkdink").value;
                var bname=document.getElementById("bname").value;
                var description=document.getElementById("description").value;
                const PP = this.profilePictureRef.current;
                const imageData = PP.getData();
                const file = imageData.file;
                const imageAsDataURL = PP.getImageAsDataUrl();
                var data=[];
                data.push(imageAsDataURL);
                data.push(name);
                data.push(addresse);
                data.push(num_tel);
                data.push(mail);
                data.push(date_n);
                data.push(linkd);
                data.push(bname);
                data.push(description);
                var o=0;
                for (var i=1;i<=parseInt(document.getElementById("btn_com").name);i++){
if(document.getElementById(i+"")!=null && document.getElementById(i+"").value!=undefined){
  data.push(document.getElementById(i+"").value);
}else{
  //alert("else")
  if(document.getElementById(i+"")!=null){
    if(document.getElementById(i+"").value==undefined){
      //document.getElementById(i+"").error
      o=1;

      break;
    }
  }
}
                }
                if(o==0){
		          this.props.history.push({
		            pathname: '/models/create_cv1/result',
		            data: data // your data array of objects
		          });  
                }else{
                //  alert("erreur");
                }
                         
                 }
      addEns(){
var div_=document.getElementById("e");
var div = document.createElement('div');
div.className = 'form-group';
var div1 = document.createElement('div');
div1.style="display:flex";

var input = document.createElement('input');
input.height="50px"
input.className = 'form-control';
//commentText.rows = '3';
input.placeholder = "L'intitule de votre formation";
input.width="100px";
input.id=document.getElementById("btn_ens").name;
document.getElementById("btn_ens").name=(parseInt(document.getElementById("btn_ens").name)+1)+"";
var input1 = document.createElement('input');
input1.height="50px"
input1.className = 'form-control';
//commentText.rows = '3';
input1.placeholder = "Nom de l'etablissment";
input1.width="100px";
input1.id=document.getElementById("btn_ens").name;
document.getElementById("btn_ens").name=(parseInt(document.getElementById("btn_ens").name)+1)+"";
var date=document.createElement("input");
date.style="margin-left:10px";
date.id=document.getElementById("btn_ens").name;
document.getElementById("btn_ens").name=(parseInt(document.getElementById("btn_ens").name)+1)+"";
var datef=document.createElement("input");
datef.style="margin-left:10px";
datef.id=document.getElementById("btn_ens").name;
document.getElementById("btn_ens").name=(parseInt(document.getElementById("btn_ens").name)+1)+"";
var br=document.createElement("br");
date.type="date";
datef.type="date";

div1.appendChild(input);
div1.appendChild(input1);
div1.appendChild(date)
div1.appendChild(datef);

//div.appendChild(div1);
div_.appendChild(div1);
div_.appendChild(br);
      }
      
        
  render(){
   

    var i=3;
      
      {if(!this.state.msg){
        return (
         
          <div style={{backgroundColor:"whitesmoke"}}>
              <Header/>
      <Toolbar/>
      
      <div  className="container" id="test" style={{borderStyle:"double" ,marginTop:"40px",height:"1250px", backgroundColor:"white"}}>
          <div className="wrapper" id="cv">
      
          <nav id="sidebar" >
              <div class="sidebar-header">
              <ProfilePicture
            ref={this.profilePictureRef}
            useHelper={true}
            debug={true}
          />
      
              </div>
      <br/>
              <ul class="list-unstyled components" style={{ marginLeft:"18px",color:"white"}}>
                  <h4 style={{color:"white"}}>Donnees Personnelles</h4>
                  <p style={{color:"white",marginTop:"8px"}}>Nom et prenom:</p>
      
                  <TextField autoComplete="fname"
                      variant="outlined"
                      size='small'
      className="form"
                      required
      
                      style={{marginTop:"-15px"}}
      
                      id="name"
                      label="Your name"
                      />
               
      
                      <p style={{color:"white",marginTop:"8px"}}>Adresse:</p>
                      <TextField autoComplete="fname"
                      variant="outlined"
                      size='small'
                      className="form"
                      style={{marginTop:"-15px"}}
      
                      required
                      id="adresse"
                      label="Your adress"
                      />
                      <p style={{color:"white",marginTop:"8px"}}>Numero de telephone:</p>
                      <TextField autoComplete="fname"
                      variant="outlined"
                      required
                      size='small'
                      className="form"
                      style={{marginTop:"-15px"}}
      
                      id="num_tel"
                      label="Your phone number"
                      />
                       <p style={{color:"white",marginTop:"8px"}}>Adresse mail:</p>
                      <TextField autoComplete="fname"
                      variant="outlined"
                      required
                      type="mail"
                      size='small'
                      className="form"
      
                      id="mail"
                      size='small'
                      style={{marginTop:"-15px"}}
      
                      label="Your email"
                      />
                       <p style={{color:"white",marginTop:"8px"}}>Date de naissance:</p>
                      <TextField autoComplete="fname"
                      variant="outlined"
                      required
                      type="date"
                      style={{marginTop:"-15px"}}
      
                      size='small'
                      className="form"
                      id="date_birth"
                      />
                      
                       <p style={{color:"white",marginTop:"8px"}}>Linkdink:</p>
                      <TextField autoComplete="fname"
                      variant="outlined"
                      required
                      style={{marginTop:"-15px"}}
                      type="text"
                      size='small'
                      className="form"
      
                      id="linkdink"
                      label="Your linkdink"
                      />
                      <hr class="solid"/>
                      <div>
      
                      </div>
              </ul>
          </nav>
      <div id="content_">
          <nav >
              <div >
              <p>Your name:</p>
              <TextField 
             
              autoComplete="fname"
                      variant="outlined"
                      required
                      
                      type="name"
                      fullWidth
                      id="bname"
                      label="Your name"
                      />
                      <br/><br/>
                      <p>Descrpition of yourself:</p>
                      <FormControl htmlSize="26" rows={4} id="description" as="textarea" aria-label="With textarea" />
                      <br/>
                      <hr class="solid"/>
                      <br/>
                      <div className="enseignement" id="e">
                      <div style={{display:"flex"}}>
                      <Icon.AwardFill size={30}/>&nbsp;<h3 class="titre">  Enseignement</h3>
                      </div>
                      <div style={{display:"flex"}} id="e_">
                      <TextField  autoComplete="fname" variant="outlined" required type="name"   id="1"
                     label="Le nom de votre parcours d'etudes"
                     style={{marginRight:"10px"}}
                     />
                      <TextField  variant="outlined" required type="text"   id="2"
                     label="Nom de l'etablissment" style={{marginRight:"10px"}}
                     />
       <TextField  variant="outlined" required type="date" label="date debut"  id="3"
                     />
                     <TextField  variant="outlined" required type="date" label="date fin"  id="4"
                     />
                    
                      </div><br/>
                        
                      </div>
                      
                      <Button onClick={this.addEns} id="btn_ens" name={i}>Ajouter une nouvelle annee</Button>
      
      
                      <br/>
                      <hr class="solid"/>
                      <br/>
                      <div className="exp" id="exp">
                      <div style={{display:"flex"}}>
                      <Icon.Basket2Fill size={30}/>&nbsp;<h3 class="titre">Experience</h3>
                      </div>
                      <div style={{display:"flex"}}>
                      <TextField  autoComplete="fname" variant="outlined" required type="name" id="13"
                     label="Intitule de l'experience "
                     style={{marginRight:"10px"}}
                     />
                     <TextField  variant="outlined" required type="text"   id="14"
                     label="Nom de l'entreprise" style={{marginRight:"10px"}}
                     />
       <TextField  variant="outlined" required type="date" label="date debut"  id="15"
                     />
                     <TextField  variant="outlined" required type="date" label="date fin"  id="16"
                     />
      
                      </div>
                      <br/>
                      </div>
                      <Button onClick={this.addExp} id="btn_exp" name="17">Ajouter une nouvelle Experience</Button>
      
                      <br/>
                      <hr class="solid"/>
                      <br/>
                      <div className="competence" id="comp">
                      <div style={{display:"flex"}}>
                      <Icon.Mouse3 size={30}/>&nbsp;<h3 class="titre">   Competence</h3>
                      </div>
                      <div style={{display:"flex"}}>
                      <TextField  autoComplete="fname" variant="outlined" required type="name" fullWidth  id="25"
                     label="Le nom de votre competence"
                     style={{marginRight:"10px"}}
                     />
       <TextField  variant="outlined" required type="number"   id="26"
                     label="niveau de competence max 5 "
                     />
                      </div>
                      <br/>
      
                      </div>
                      <Button onClick={this.addCom} id="btn_com" name="27">Ajouter une nouvelle competence</Button>
      
              </div>
          </nav>
      </div>
              </div> 
      
      
      </div>
      <br/>
      <Fab variant="extended" onClick={this.handelSubmit} id="annuler">
        Annuler
        <Icon.Download  />
      </Fab>
      <Fab variant="extended" onClick={() => this.toresult()} id="pdf">
        Finis?
        <Icon.Download  />
      </Fab><br/>
      <br/>
      
          </div>
      )
      }
    else{
      return (
        <div style={{backgroundColor:"whitesmoke"}}>
          
          <Modal show={true} >
        <Modal.Header closeButton>
          <Modal.Title>Quitter</Modal.Title>
        </Modal.Header>
        <Modal.Body>Si vous quitter cette page les changement seront perdu!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" >
            Fermer
          </Button>
          <Button variant="danger" onClick={()=>window.location.href="/models"}>
            Confirmer
          </Button>
        </Modal.Footer>
      </Modal>
            <Header/>
    <Toolbar/>
    
    <div  className="container" id="test" style={{borderStyle:"double" ,marginTop:"40px",height:"1250px", backgroundColor:"white"}}>
        <div className="wrapper" id="cv">
    
        <nav id="sidebar" >
            <div class="sidebar-header">
            <img
          
        />
      
            </div>
    <br/>
            <ul class="list-unstyled components" style={{ marginLeft:"18px",color:"white"}}>
                <h4 style={{color:"white"}}>Donnees Personnelles</h4>
                <p style={{color:"white",marginTop:"8px"}}>Nom et prenom:</p>
    
                <TextField autoComplete="fname"
                    variant="outlined"
                    size='small'
    className="form"
                    required
    
                    style={{marginTop:"-15px"}}
    
                    id="name"
                    label="Your name"
                    />
             
    
                    <p style={{color:"white",marginTop:"8px"}}>Adresse:</p>
                    <TextField autoComplete="fname"
                    variant="outlined"
                    size='small'
                    className="form"
                    style={{marginTop:"-15px"}}
    
                    required
                    id="adresse"
                    label="Your adress"
                    />
                    <p style={{color:"white",marginTop:"8px"}}>Numero de telephone:</p>
                    <TextField autoComplete="fname"
                    variant="outlined"
                    required
                    size='small'
                    className="form"
                    style={{marginTop:"-15px"}}
    
                    id="num_tel"
                    label="Your phone number"
                    />
                     <p style={{color:"white",marginTop:"8px"}}>Adresse mail:</p>
                    <TextField autoComplete="fname"
                    variant="outlined"
                    required
                    type="mail"
                    size='small'
                    className="form"
    
                    id="mail"
                    size='small'
                    style={{marginTop:"-15px"}}
    
                    label="Your email"
                    />
                     <p style={{color:"white",marginTop:"8px"}}>Date de naissance:</p>
                    <TextField autoComplete="fname"
                    variant="outlined"
                    required
                    type="date"
                    style={{marginTop:"-15px"}}
    
                    size='small'
                    className="form"
                    id="date_birth"
                    />
                    
                     <p style={{color:"white",marginTop:"8px"}}>Linkdink:</p>
                    <TextField autoComplete="fname"
                    variant="outlined"
                    required
                    style={{marginTop:"-15px"}}
                    type="text"
                    size='small'
                    className="form"
    
                    id="linkdink"
                    label="Your linkdink"
                    />
                    <hr class="solid"/>
                    <div>
    
                    </div>
            </ul>
        </nav>
    <div id="content_">
        <nav >
            <div >
            <p>Your name:</p>
            <TextField 
           
            autoComplete="fname"
                    variant="outlined"
                    required
                    
                    type="name"
                    fullWidth
                    id="bname"
                    label="Your name"
                    />
                    <br/><br/>
                    <p>Descrpition of yourself:</p>
                    <FormControl htmlSize="26" rows={4} id="description" as="textarea" aria-label="With textarea" />
                    <br/>
                    <hr class="solid"/>
                    <br/>
                    <div className="enseignement" id="e">
                    <div style={{display:"flex"}}>
                    <Icon.AwardFill size={30}/>&nbsp;<h3 class="titre">  Enseignement</h3>
                    </div>
                    <div style={{display:"flex"}} id="e_">
                    <TextField  autoComplete="fname" variant="outlined" required type="name"   id="1"
                   label="Le nom de votre parcours d'etudes"
                   style={{marginRight:"10px"}}
                   />
                    <TextField  variant="outlined" required type="text"   id="2"
                   label="Nom de l'etablissment" style={{marginRight:"10px"}}
                   />
     <TextField  variant="outlined" required type="date" label="date debut"  id="3"
                   />
                   <TextField  variant="outlined" required type="date" label="date fin"  id="4"
                   />
                  
                    </div><br/>
                      
                    </div>
                    
                    <Button onClick={this.addEns} id="btn_ens" name={i}>Ajouter une nouvelle annee</Button>
    
    
                    <br/>
                    <hr class="solid"/>
                    <br/>
                    <div className="exp" id="exp">
                    <div style={{display:"flex"}}>
                    <Icon.Basket2Fill size={30}/>&nbsp;<h3 class="titre">Experience</h3>
                    </div>
                    <div style={{display:"flex"}}>
                    <TextField  autoComplete="fname" variant="outlined" required type="name" id="13"
                   label="Intitule de l'experience "
                   style={{marginRight:"10px"}}
                   />
                   <TextField  variant="outlined" required type="text"   id="14"
                   label="Nom de l'entreprise" style={{marginRight:"10px"}}
                   />
     <TextField  variant="outlined" required type="date" label="date debut"  id="15"
                   />
                   <TextField  variant="outlined" required type="date" label="date fin"  id="16"
                   />
    
                    </div>
                    <br/>
                    </div>
                    <Button onClick={this.addExp} id="btn_exp" name="17">Ajouter une nouvelle Experience</Button>
    
                    <br/>
                    <hr class="solid"/>
                    <br/>
                    <div className="competence" id="comp">
                    <div style={{display:"flex"}}>
                    <Icon.Mouse3 size={30}/>&nbsp;<h3 class="titre">   Competence</h3>
                    </div>
                    <div style={{display:"flex"}}>
                    <TextField  autoComplete="fname" variant="outlined" required type="name" fullWidth  id="25"
                   label="Le nom de votre competence"
                   style={{marginRight:"10px"}}
                   />
     <TextField  variant="outlined" required type="number"   id="26"
                   label="niveau de competence max 5 "
                   />
                    </div>
                    <br/>
    
                    </div>
                    <Button onClick={this.addCom} id="btn_com" name="27">Ajouter une nouvelle competence</Button>
    
            </div>
        </nav>
    </div>
            </div> 
    
    
    </div>
    <br/>
    
    <Fab variant="extended" onClick={() => this.toresult()} id="pdf">
      Finis?
      <Icon.Download  />
    </Fab><br/>
    <br/>
    
        </div>
    )
    }
    }


 

}

}
